import FiltersIconPath from "@ingka/ssr-icon/paths/filters";

export default FiltersIconPath;
